import { useQuery } from '@apollo/client';
import { EmailEditor } from '@nile/banyan/src/Components/Editors';
import { TEMPLATE_TYPES } from '@nile/banyan/src/Constants/notifications';
import { GET_NOTIFICATION_TEMPLATES } from '@nile/banyan/src/Graphql/Mutations/templates';
import {
  AIComponent,
  AccessControl,
  ActionButtons,
  B1,
  CHAT_ACTION_TEXT,
  Editor,
  EventEmitter,
  FieldTitle,
  Loader,
  P1,
  T2,
  TICKET_SOURCE,
  fetchApi,
  findLastIndex,
  getAIRephraseKeys,
  getHeaderValue,
  getTranslatedText,
  toast,
  useActivityTracker
} from '@nile/components';
import {
  dompurifier,
  formatContentWithMentionsAndPlaceholders
} from '@nile/components/src/Utils/helpers';
import {
  APPLY_AI_PROMPT,
  AccountClient,
  SAVE_TICKET_CONVERSATION,
  SAVE_TICKET_INTEGRATION_CONVERSATION,
  TicketClient
} from '@nile/graphql';
import { GET_CLIENT_USERS } from '@nile/graphql/src/Query/client';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { SelectUsers } from '@nile/mangifera/src/Pebbles/ChatContainer';
import { getTabId } from '@nile/mangifera/src/Pebbles/TabManager';
import TimerActionsFromReply from '@nile/components/src/Containers/NewWorklog/TimerActionsFromReply';
import { SVGIcon } from '@superops/super-icons';
import BannerComponent from '../../Components/BannerComponent.tsx';
import {
  Avatar,
  Badge,
  Banner,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  Popover,
  Select,
  Sheet,
  TextStyle
} from '@superops/ui-design-system';
import Tippy from '@tippyjs/react';
import { cloneDeep, isEmpty, isEqual } from 'lodash';
import React, { Component, useCallback, useState } from 'react';
import { Tooltip } from 'react-clone-tippy';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import styled from 'styled-components';
import dompurify from 'dompurify';
import GlobalTicketConversationAction from '@nile/mangifera/src/Containers/ChatContainers/GlobalTicketConversationAction';
import GlobalTicketConversationUsers from '@nile/mangifera/src/Containers/ChatContainers/GlobalTicketConversationUsers';
import { getGlobalConversations } from '@nile/components/src/Components/GlobalChatHook';
import TicketNoteAIActions from '@nile/mangifera/src/Components/AI/TicketNoteAIActions.js';
import ArticleSearchSheet from '@nile/rmm/src/modules/knowledge-base/components/ArticleSearchSheet';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const StyledChatContainer = styled.div`
  position: ${(props) => props?.isDescOrder && 'sticky'};
  bottom: ${(props) => props?.isDescOrder && '20px'};

  .fr-wrapper {
    max-height: ${(props) => props?.isDescOrder && '300px'};
    overflow: ${(props) => props?.isDescOrder && 'auto'};

    /* Hide scrollbar by default */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE */

    /* Hide scrollbar for Chrome/Safari/Webkit */
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background: transparent;
    }

    /* Show scrollbar on hover */
    &:hover {
      scrollbar-width: thin; /* Firefox */
      -ms-overflow-style: auto; /* IE */

      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 10px;
      }
    }
  }

  .fr-wrapper .Superops-Card {
    background: ${(props) => props.color || '#ffffff'};
    ul {
      list-style: initial;
    }
  }
  border-radius: 10px;
  .ql-editor {
    padding: 0 !important;
  }
  .Polaris-ButtonGroup {
    display: flex;
    flex-wrap: nowrap;
  }
  .ql-toolbar {
    padding: 0 !important;
  }
  .end {
    padding: 0;
    // padding-top: 20px;
  }
`;

export const CopyMailUsers = styled.div.attrs({
  className: 'flex center full-width'
})`
  .select-wrapper {
    width: 100%;
  }
  .container {
    width: 100%;
    margin-right: 0;
  }
  .value_selector__control {
    border: none;
  }
`;

export const EditorHolder = styled.div`
  // min-height: 200px;
  height: ${(props) =>
    props?.isBannerVisible ? 'calc(100% - 180px)' : 'calc(100% - 100px)'};
`;

export const EmailEditorHolder = styled.div`
  #quill-rt-editor {
    height: 100%;
    .quill {
      min-height: 200px;
      .ql-container {
        border: none;
        min-height: inherit;
        .ql-editor {
          min-height: inherit;
        }
      }
    }
    .ql-toolbar {
      border: none;
    }
  }
  .ql-editor.ql-blank::before {
    left: 10px;
  }
`;

export const ListWrapper = styled.div`
  width: 30vw;
  height: 100vh;
  background: #fff;
  padding: 12px;
  overflow: auto;
`;

export const Header = styled.div`
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
`;

export const Template = styled.div`
  margin-bottom: 10px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  display: -webkit-box;
  max-height: 100px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
  p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
`;

export const SenderHolder = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  align-self: start;
  .Polaris-Button {
    padding: 11px !important;
  }
`;

export const CC = styled.div`
  font-weight: 500;
  color: black;
  margin-right: 12px;
  cursor: pointer;
`;

export const EditorHeader = styled.div`
  align-items: center;
`;

export const MailboxItem = styled.div`
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;

  ${(props) => !props?.isVerified && `color: #00000080;`}

  &:hover {
    background: #ececec;
  }
`;

export const MailboxItemHolder = styled.div`
  padding: 5px;
`;

export const EmailStatus = styled.span`
  padding: 0 8px;
  color: #ff0055;
  svg {
    margin-right: 8px;
  }
`;

export const ToolTipContainer = styled.div`
  padding: 5px 10px;
`;

export const TypingStatus = styled.div`
  color: #4b8413;
`;

export const Item = styled.div`
  height: 24px;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  margin-right: 8px;
  line-height: 20px;
  margin-bottom: 2px;
  align-items: center;
  background: #f2f5ff;
  border-radius: 12px;
  padding: 2px 8px 2px 1px;
`;

export const Delete = styled.div`
  margin-left: 4px;
  cursor: pointer;
  outline: none;
`;

function ReplyTemplateList(props) {
  const { loading, error, data } = useQuery(GET_NOTIFICATION_TEMPLATES, {
    client: AccountClient,
    variables: { notificationTemplateType: TEMPLATE_TYPES.reply },
    fetchPolicy: 'network-only'
  });
  if (loading) return <div>loading...</div>;
  if (error) return <div>error...</div>;
  const populateTemplateContent = (template) => {
    props.toggleSheetActive();
    props.populateTemplate(template);
  };
  return (
    <ListWrapper>
      <Header>Reply templates</Header>
      {data.getNotificationTemplates.map((el) => {
        return (
          <Template onClick={populateTemplateContent.bind(this, el)}>
            <FieldTitle>{el.name}</FieldTitle>
          </Template>
        );
      })}
    </ListWrapper>
  );
}

function HiddenActions(props) {
  const [ccVisible, setCcVisible] = useState(false);
  const [bccVisible, setBccVisible] = useState(false);
  const [sheetActive, setSheetActive] = useState(false);

  const toggleSheetActive = useCallback(
    () => setSheetActive((active) => !active),
    []
  );

  const populateTemplate = (template) => {
    props.updateTemplateContent(template);
  };

  const handleCc = () => {
    setCcVisible(true);
    props.updateState('showCc', true);
  };

  const handleBcc = () => {
    setBccVisible(true);
    props.updateState('showBcc', true);
  };

  return (
    <SenderHolder>
      <div className="flex g10">
        {!ccVisible && (
          <div className="pointer" onClick={handleCc}>
            <TextStyle weight="Medium">CC</TextStyle>
          </div>
        )}
        {!bccVisible && (
          <div className="pointer" onClick={handleBcc}>
            <TextStyle weight="Medium">BCC</TextStyle>
          </div>
        )}
      </div>

      {!props?.globalConversationFlag && (
        <>
          <Button id="actionReplyTemplates" onClick={toggleSheetActive}>
            <SVGIcon name="ReplyBubble" />
          </Button>

          <Sheet open={sheetActive} onClose={toggleSheetActive}>
            <ReplyTemplateList
              populateTemplate={populateTemplate}
              toggleSheetActive={toggleSheetActive}
            />
          </Sheet>
        </>
      )}
    </SenderHolder>
  );
}

const ToolbarActions = (props) => {
  const {
    pinChat,
    disabled,
    updateTemplateContent,
    ticketId,
    onArticleCopy,
    source
  } = props;
  const intl = useIntl();
  const flags = useFlags();

  const aiRephraseKeys = getAIRephraseKeys(intl);

  const [ccVisible, setCcVisible] = useState(false);
  const [bccVisible, setBccVisible] = useState(false);

  const handleCc = () => {
    setCcVisible(true);
    props.updateState('showCc', true);
  };

  const handleBcc = () => {
    setBccVisible(true);
    props.updateState('showBcc', true);
  };

  const [showKb, setShowKb] = useState(false);
  const toggleKBSheetActive = useCallback(
    () => setShowKb((prevState) => !prevState),
    []
  );

  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback(
    () => setSheetActive((active) => !active),
    []
  );

  const populateTemplate = (template) => {
    updateTemplateContent(template);
  };

  return (
    <div>
      <div className="flex g10 actr jend mb10">
        <div>
          {props?.showAIRephrase && (
            <AIComponent
              editorRef={props?.editorRef}
              onCopy={props?.onAIRephraseCopy}
              type="REPHRASE"
              hideButtonText
              prompts={props?.prompts || []}
              data={{
                Api: APPLY_AI_PROMPT,
                accessorKey: 'applyAIPrompt'
              }}
              sendFeedback={props?.sendFeedback}
              featureName="PROMPT_BUILDER"
              headingText={getTranslatedText(intl, 'common.rephrased.text')}
              headingIcon={'AIWand'}
              loadingText={aiRephraseKeys?.loadingText}
              successText={aiRephraseKeys?.successText}
              copyButtonText={getTranslatedText(intl, 'common.insert.text')}
              copySuccessText={getTranslatedText(intl, 'common.inserted')}
              mixpanelEventOnClick={{
                event: 'Rephrased with prompt - Ticket conversation reply',
                data: {
                  ticketId: ticketId
                }
              }}
              mixpanelEventOnCopy={{
                event:
                  'Copy and pasted rephrased content - Ticket conversation reply',
                data: {
                  ticketId: ticketId
                }
              }}
            />
          )}
        </div>
        <AccessControl
          roleToCheck="knowledgeBase.view"
          render={
            <div>
              <Tooltip
                title={getTranslatedText(intl, 'common.knowledge.base')}
                inertia
                trigger="mouseenter"
                animation="shift"
                animateFill={false}
                className="tooltip"
                position="bottom"
              >
                <Button
                  id="actionKbTemplates"
                  plain
                  onClick={toggleKBSheetActive}
                  icon={<SVGIcon name="Notes" />}
                ></Button>
              </Tooltip>

              <Sheet open={showKb} onClose={toggleKBSheetActive}>
                <ArticleSearchSheet
                  toggleKBSheetActive={toggleKBSheetActive}
                  ticketId={ticketId}
                  insertLink={onArticleCopy}
                />
              </Sheet>
            </div>
          }
        />
        <Tooltip
          title={getTranslatedText(intl, 'ticket.conversation.shift.screen')}
          inertia
          trigger="mouseenter"
          animation="shift"
          animateFill={false}
          className="tooltip"
          position="bottom"
        >
          <Button
            plain
            icon={<SVGIcon name="ShiftScreen" />}
            onClick={pinChat}
            disabled={disabled}
          ></Button>
        </Tooltip>

        {source !== TICKET_SOURCE.Communication && (
          <div>
            <Tooltip
              title={getTranslatedText(
                intl,
                'admin.templates.create.replyTemplate'
              )}
              inertia
              trigger="mouseenter"
              animation="shift"
              animateFill={false}
              className="tooltip"
              position="bottom"
            >
              <Button
                id="actionReplyTemplates"
                plain
                onClick={toggleSheetActive}
                icon={<SVGIcon name="ReplyBubble" />}
              ></Button>
            </Tooltip>

            <Sheet open={sheetActive} onClose={toggleSheetActive}>
              <ReplyTemplateList
                populateTemplate={populateTemplate}
                toggleSheetActive={toggleSheetActive}
              />
            </Sheet>
          </div>
        )}
      </div>

      <div className="flex g10 jend">
        {!ccVisible && source !== TICKET_SOURCE.Communication && (
          <div className="pointer" onClick={handleCc}>
            <TextStyle weight="Medium">CC</TextStyle>
          </div>
        )}
        {!bccVisible && source !== TICKET_SOURCE.Communication && (
          <div className="pointer" onClick={handleBcc}>
            <TextStyle weight="Medium">BCC</TextStyle>
          </div>
        )}
      </div>
    </div>
  );
};

class ActionContainer extends Component {
  static contextType = TabContext;

  constructor(props) {
    super(props);
    this.state = {
      isEditMode: true,
      // editorState: EditorState.createEmpty(),
      template: props.storedTemplate || {
        name: '',
        content: dompurifier(props.template) || '',
        placeholdersUsed: '',
        mentions: [],
        attachments: props?.attachmentsFromReplyTemplate || [],
        inlineImages: []
      },
      placeholders: props.placeholders ? props.placeholders : [],
      ccUsers: props.recipients?.cc
        ? this.getFormattedCCUSers(props.recipients.cc)
        : [],
      bccUsers: [],
      recipients:
        props.recipients?.conversationThreads?.length > 0
          ? this.getFormattedRecipients(props.recipients?.conversationThreads)
          : [],
      submitActionLoading: false,
      showCc: props.recipients?.cc?.length > 0,
      showBcc: false,
      isUploading: false,
      isDisabled: false,
      mailboxes: props.recipients?.mailboxes || [],
      selectedMailbox:
        props?.mailBoxGlobalState || props.recipients?.selectedMailbox || null,
      popoverActive: false,
      isPublicNote: false,
      editorWidthIsSmall: false,
      hideToolbar: props.hideToolbar !== undefined ? props.hideToolbar : true,
      isBannerVisible: false,
      isPrivateChannel: false
    };
    this.editorRef = React.createRef(null);
    this.editorContainerRef = React.createRef();
    this.currentUser = this.props?.appContext?.user || {};
    this.recipientsConfig = {
      property: 'recipientId',
      query: GET_CLIENT_USERS,
      params: {
        client: AccountClient,
        variables: { input: { clientId: this.props.ticket?.client?.accountId } }
      },
      methodName: 'getClientUserAssociationsList',
      generateOptions: this.generateReceiverOptions,
      customOptionComponent: this.customOptionComponent,
      customMultiValueComponent: this.customMultiValueComponent,
      isMulti: true,
      field: 'recipients',
      placeholder: getTranslatedText(
        this.props.intl,
        'common.choose.technician'
      ),
      errors: '',
      styles: {
        multiValueRemove: (base, state) => {
          if (state.data.isFixed) {
            return { ...base, display: 'none' };
          }
          return base;
        }
      },
      isClearable: false
    };

    this.timer = null;
  }

  globalConversationFlag = this.props?.globalConversationFlag;

  componentDidMount() {
    EventEmitter.subscribe('editorContentChange', this.updateEditorState);
    EventEmitter.subscribe('imageUploading', this.handleDisableButtons);
    EventEmitter.subscribe('closeTab', this.handleTabClose);
    // EventEmitter.subscribe('sendTicketConversation', this.onMessageSubmit);
    if (
      this.props?.module === 'TICKET_CONVERSATION' &&
      this.props.ccAvailable &&
      this.props.ticket?.source !== TICKET_SOURCE.Communication &&
      !this.props.recipients?.selectedMailbox?.outgoingDomainVerified &&
      !this?.state?.isDisabled
    ) {
      this.handleDisableButtons(true);
    }
    if (this.props.setInstance) {
      this.props.setInstance(this);
    }
    this.handlePageResize();
    window.addEventListener('resize', this.handlePageResize);
    // IF PARENT REF IS PASSED WE EXPOSE THIS COMPONENT WHEN UPDATED
    if (this.props.parentRef) {
      this.props.parentRef.current = this;
    }

    if (this.props.ccAvailable && this.props.data?.length) {
      const lastThreadConversation = this.props.data
        .filter((conv) => conv?.type === 'THREAD_CONVERSATION')
        .map((conv) => conv.threadConversation)
        .findLast((conv) => conv?.conversationScope);
      const isPrivateChannel =
        lastThreadConversation?.conversationScope === 'PRIVATE';
      this.setState((prev) => {
        return {
          ...prev,
          isPrivateChannel: isPrivateChannel
        };
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.template !== this.props.template) {
      this.setState({
        template: {
          ...this.state.template,
          content: dompurifier(this.props.template)
        }
      });
    }
    if (
      this.props.storedTemplate &&
      !isEqual(prevProps.storedTemplate, this.props.storedTemplate)
    ) {
      this.setState({
        template: {
          ...this.props.storedTemplate
        }
      });
    }
    if (!isEqual(this.props.recipients, prevProps.recipients)) {
      this.setState({
        ccUsers: this.props?.recipients?.cc
          ? this.getFormattedCCUSers(this.props?.recipients?.cc)
          : [],
        showCc: this.props.recipients?.cc?.length > 0,
        mailboxes: this.props.recipients?.mailboxes || [],
        selectedMailbox: this.props.recipients?.selectedMailbox || null
      });
    }
    if (
      this.props?.module === 'TICKET_CONVERSATION' &&
      this.props.ccAvailable
    ) {
      // if Requester is empty send button is disabled
      if (isEmpty(this.props?.ticket?.requester) && !this?.state?.isDisabled) {
        this.handleDisableButtons(true);
      }
      // if selectedMailbox is not verified send button is disabled
      if (!isEqual(prevState.selectedMailbox, this.state?.selectedMailbox)) {
        this.setState({
          isDisabled: !this.state?.selectedMailbox?.outgoingDomainVerified
        });
      }
    } else if (this?.state?.isDisabled) {
      // this.handleDisableButtons(false);
    }

    if (
      (this.props.module === 'TICKET_CONVERSATION' ||
        this.props.module === 'NOTE') &&
      !isEqual(prevState.template.content, this.state.template.content)
    ) {
      this.editorRef.current.updateEditorContent(this.state.template.content);
    }
    // IF PARENT REF IS PASSED WE EXPOSE THIS COMPONENT WHEN UPDATED
    if (this.props.parentRef) {
      this.props.parentRef.current = this;
    }
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe('editorContentChange');
    EventEmitter.unsubscribe('imageUploading');
    EventEmitter.unsubscribe('closeTab');
    // EventEmitter.unsubscribe('sendTicketConversation');
    // if (this.props?.metadata) {
    //   const tabId = getTabId(this.props.metadata);
    //   this.context.updateGlobalState({
    //     [tabId]: {
    //       [this.props.metadata.module]: this.state.template
    //     }
    //   });
    // }
  }

  handlePageResize = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.setState({
        editorWidthIsSmall:
          this.editorContainerRef?.current?.getBoundingClientRect()?.width < 710
      });
    }, 1000);
  };

  getFormattedCCUSers = (users) => {
    const allCCUsers = users.map((el) => {
      return this.getValueForDropdown(el);
    });
    return allCCUsers;
  };

  getFormattedRecipients = (threads) => {
    const formatRecipient = (receiver) => ({
      ...receiver,
      name: receiver?.user?.name,
      value: receiver?.user?.email,
      label: receiver?.user?.name, // showing name in the dropdown
      isFixed: true // default - unable to deselect from dropdown
    });

    const privateThreads = threads?.filter((thread) => {
      return thread?.conversationScope === 'PRIVATE';
    });

    const uniqueRecipients = privateThreads
      .flatMap((thread) => thread?.recipients?.receiver || [])
      .reduce((acc, item) => {
        const key = item?.user?.userId || item?.user?.email || item?.label;
        return { ...acc, [key]: item };
      }, {});

    return Object.values(uniqueRecipients).map(formatRecipient);
  };

  handleTabClose = () => {
    if (this.props.saveState) {
      const tabId = getTabId({ module: 'TICKET', data: this.props.ticket });
      this.props.context.updateGlobalStateCustom({
        [this.props.ticket.ticketId]: {}
      });
    }
  };

  getValueForDropdown = (user) => {
    return {
      ...user,
      name: user.name || user.email,
      value: user.name || user.email,
      label: user.name || user.email
    };
  };
  /**
   * Take the cc users from the latest reply
   * It can be either technician or requester's reply
   * If a person in cc replies via email, then we should include that
   * person in cc automatically if that user is not a requester/ a custom email.
   * Also, add to cc if there are cc when a ticket is created from email and if cc is appended there.
   * The type is 'DESCRIPTION' for that case.
   */

  getCCUsers = () => {
    const replyIndex = findLastIndex(this.props.data, 'messageType', [
      'TECH_REPLY',
      'REQ_REPLY',
      'DESCRIPTION'
    ]);
    const lastReplyFromRequesterIndex = findLastIndex(
      this.props.data,
      'messageType',
      ['REQ_REPLY']
    );
    let allCCUsers = [];
    if (this.props.data) {
      const users = this.props.data[replyIndex]?.ccUsers || [];
      allCCUsers = users.map((el) => {
        return this.getValueForDropdown(el.user);
      });
      // append the latest req reply user to the list of cc users
      // if they're not already present in the cc list
      const lastReplyUser = this.props.data[lastReplyFromRequesterIndex]?.user;
      if (
        lastReplyUser &&
        this.props.ticket.requester.email !== lastReplyUser.email &&
        allCCUsers.findIndex((el) => el.email === lastReplyUser.email) === -1
      ) {
        allCCUsers = allCCUsers.concat([
          this.getValueForDropdown({
            ...lastReplyUser,
            name: lastReplyUser.firstName
              ? `${lastReplyUser.firstName} ${lastReplyUser.lastName}`
              : null
          })
        ]);
      }
      return allCCUsers;
    }
    return [];
  };

  handleDisableButtons = (val) => {
    this.setState({ isDisabled: val });
  };

  updateEditorState = (c) => {
    this.updateTemplate({ content: c });
  };

  updateTemplate = (obj) => {
    const clonedTemplate = cloneDeep(this.state.template);
    const updatedTemplate = { ...clonedTemplate, ...obj };
    this.setState({ template: updatedTemplate });
  };

  updateState = (field, value) => {
    this.setState({ [field]: value });
  };

  updateTemplateContent = (newTemplate) => {
    this.props.refetchDefaultReplyTemplate(
      {
        input: {
          ticket: {
            ticketId: this.props.ticket.ticketId
          },
          mailbox: {
            boxId: this.state.selectedMailbox.boxId
          },
          template: {
            templateId: newTemplate.id
          }
        }
      },
      (content) => {
        EventEmitter.dispatch('insertEditorContent', content);
      }
    );
  };

  handleFileAttachments = (files, callBack) => {
    const formData = new FormData();
    // formData.append('files', files);
    files.forEach((file, idx) => {
      formData.append(`files`, file);
    });

    const { uploadParams, attachmentUploadUrl } = this.props;
    // if (template?.id) {
    //   formData.append('notificationTemplateId', template.id);
    // }
    for (const property in uploadParams) {
      formData.append(property, uploadParams[property]);
    }

    this.setState({ isUploading: true });
    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: getHeaderValue()
    };
    fetchApi(attachmentUploadUrl, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response?.errors) {
          throw new Error(response.errors?.[0]?.errorMessage);
        }
        return response.data;
      })
      .then((list) => {
        const updatedList = [
          ...cloneDeep(this.state.template?.attachments),
          ...list
        ];
        this.updateTemplate({ attachments: updatedList });
      })
      .catch((error) => {
        toast('error', error?.message);
        console.error('Error:', error?.message);
      })
      .finally(() => {
        this.setState({ isUploading: false });
        if (callBack) callBack();
      });
  };

  addAttachments = (attachmentsToAdd) => {
    const updatedAttachments = cloneDeep(this.state.template?.attachments);
    attachmentsToAdd.forEach((el) => {
      const isFilePresent = updatedAttachments.find(
        (file) =>
          file?.name === el?.name &&
          file?.originalFileName === el?.originalFileName
      );
      if (!isFilePresent) {
        updatedAttachments.push(el);
      }
    });
    this.updateTemplate({ attachments: updatedAttachments });
  };

  clearContent = (success) => {
    if (success) {
      this.setState({
        template: {
          name: '',
          content: '',
          placeholdersUsed: '',
          mentions: [],
          attachments: [],
          inlineImages: []
        },
        ccUsers: this.props?.recipients?.cc
          ? this.getFormattedCCUSers(this.props.recipients.cc)
          : [],
        bccUsers: [],
        submitActionLoading: false,
        isPublicNote: false
      });
    } else {
      this.setState({ submitActionLoading: false });
    }
    if (
      // this.props.module !== 'TICKET_NOTE' &&
      this.props.mode !== 'conversation' &&
      this.props.mode !== 'note' &&
      this.props.changeChatMode
    ) {
      this.props.changeChatMode('feed');
    }
    if (this.props.saveState) {
      const cacheKey = {
        note: 'TICKET_NOTE',
        conversation: 'TICKET_CONVERSATION',
        feed: 'TICKET_CONVERSATION'
      };
      const tabId = getTabId({ module: 'TICKET', data: this.props.ticket });
      const { ticketId } = this.props.ticket;
      const currentValue = this.props.context?.globalState?.[ticketId] || {};
      this.props.context.updateGlobalStateCustom({
        [ticketId]: {
          ...currentValue,
          [cacheKey[this.props.mode]]: {}
        }
      });
    }
  };

  appendRequestData = (data) => {
    // if ticket source is instant messaging then append recipient details and conversation scope
    let recipientDetails = [];
    if (this.props.ticket?.source === TICKET_SOURCE.Communication) {
      if (this.state.isPrivateChannel) {
        recipientDetails = this.state.recipients?.map((el) => {
          return {
            user: {
              userId: el?.user?.userId
            },
            referenceId: el?.referenceId || null,
            label: el?.user?.email, // send email as label
            name: el?.user?.name,
            recipientType: 'RECEIVER'
          };
        });
      }
      let senderPresentInReceipeint = recipientDetails?.some(
        (el) => (el?.user?.email || el?.label) === this.currentUser?.email
      );
      if (!senderPresentInReceipeint) {
        recipientDetails = [
          ...recipientDetails,
          {
            user: {
              userId: this.currentUser?.userId
            },
            referenceId: null,
            label: this.currentUser?.email,
            name: this.currentUser?.name,
            recipientType: 'SENDER'
          }
        ];
      }
      data.recipientDetails = recipientDetails;
      data.conversationScope =
        this.state.isPrivateChannel === true ? 'PRIVATE' : 'PUBLIC';
    }
  };

  onMessageSubmit = (status) => {
    this.setState({ submitActionLoading: true });
    const formattedContent = this.props?.allowMentions
      ? formatContentWithMentionsAndPlaceholders(this.state.template?.content)
      : this.state.template?.content;
    const data = {
      message: dompurifier(formattedContent) || '',
      ccUsers: this.state.ccUsers || [],
      bccUsers: this.state.bccUsers || [],
      mentions: this.state.template?.mentions || [],
      attachments: this.state.template?.attachments || [],
      inlineImages: this.state.template?.inlineImages || [],
      type: status?.name,
      selectedMailbox: this.state.selectedMailbox
    };
    this.appendRequestData(data);

    if (this.props?.enablePublic) {
      data.privacyType = this.state.isPublicNote ? 'PUBLIC' : 'PRIVATE';
    }

    this.props.onMessageSubmit(data, this.clearContent);
    sessionStorage.removeItem('closeTicketClicked');
    sessionStorage.removeItem('suppressCloseNotificationClicked');
    if (status.statusType === 'close') {
      sessionStorage.setItem('closeTicketClicked', true);
    }
  };

  onMessageSubmitWithoutNotif = (type) => {
    this.setState({ submitActionLoading: true });
    const data = {
      message: dompurifier(this.state.template?.content) || '',
      ccUsers: this.state.ccUsers || [],
      bccUsers: this.state.bccUsers || [],
      mentions: this.state.template?.mentions || [],
      attachments: this.state.template?.attachments || [],
      inlineImages: this.state.template?.inlineImages || [],
      type: type,
      suppressCloseNotification: true,
      selectedMailbox: this.state.selectedMailbox
    };

    this.appendRequestData(data);
    if (this.props?.enablePublic) {
      data.privacyType = this.state.isPublicNote ? 'PUBLIC' : 'PRIVATE';
    }

    this.props.onMessageSubmit(data, this.clearContent);
    sessionStorage.removeItem('closeTicketClicked');
    sessionStorage.setItem('suppressCloseNotificationClicked', true);
  };

  updateCopyUsers = (type, val) => {
    this.setState({
      [type]: val
    });
  };

  handleAttachmentsDeletion = (fileName) => {
    // TODO: CURRENTLY NO API TO REMOVE FILE FROM S3. NEED SUPPORT FROM BE
    // if (template?.id) {
    //   AccountClient.mutate({
    //     mutation: DELETE_NOTIFICATION_TEMPLATE_ATTACHMENT,
    //     variables: { notificationTemplateId: template.id, fileName }
    //   }).then((res) => {
    //     if (res?.data?.deleteNotificationTemplateAttachment) {
    //       const updatedList = cloneDeep(
    //         this.state.template?.attachments
    //       ).filter((item) => item.fileName !== fileName);
    //       this.updateTemplate({ attachments: updatedList });
    //     }
    //   });
    // } else {
    const updatedList = cloneDeep(this.state.template?.attachments).filter(
      (item) => item.fileName !== fileName
    );
    this.updateTemplate({ attachments: updatedList });
    // }
  };

  togglePopoverActive = () => {
    this.setState({ popoverActive: !this.state.popoverActive });
  };

  getSaveRestrictedError = (intl) => {
    if (this.props.ccAvailable) {
      if (isEmpty(this.props?.ticket?.requester)) {
        return getTranslatedText(
          intl,
          'ticket.details.requestor.empty.errorMsg'
        );
      }
      if (!this.state?.selectedMailbox?.outgoingDomainVerified) {
        return getTranslatedText(
          intl,
          'ticket.details.mailbox.email.unverified'
        );
      }
    }
    return null;
  };

  updateNoteAsPublic = (value) => {
    this.setState({ isPublicNote: value });
  };

  // For global conversation
  formatData = (params) => {
    const ccUsers = [];
    const bccUsers = [];
    let recipients = [];
    const attachments = params?.template?.attachments
      ? params?.template?.attachments.map((el) => {
          const { fileName, originalFileName, fileSize } = el;
          return {
            fileName,
            originalFileName,
            fileSize
          };
        })
      : [];
    params?.ccUsers?.forEach((el) => {
      if (el?.email) {
        ccUsers.push({
          email: el?.email
        });
      }
    });
    params?.bccUsers?.forEach((el) => {
      if (el?.email) {
        bccUsers.push({
          email: el?.email
        });
      }
    });

    let variables = {
      ticketId: params?.data?.ticketId,
      content: params?.template?.content,
      attachments: attachments
    };

    // For private conversation - Instant Messaging
    if (params?.data?.source === TICKET_SOURCE.Communication) {
      if (params?.conversationScope === 'PRIVATE') {
        recipients = params?.recipients?.map((el) => {
          return {
            user: {
              userId: el?.user?.userId
            },
            referenceId: el?.referenceId || null,
            label: el?.user?.email, // send email as label
            name: el?.user?.name,
            recipientType: 'RECEIVER'
          };
        });
      }
      let senderPresentInReceipeint = recipients?.some(
        (el) => (el?.user?.email || el?.label) === this.currentUser?.email
      );
      if (!senderPresentInReceipeint) {
        recipients = [
          ...recipients,
          {
            user: {
              userId: this.currentUser?.userId
            },
            referenceId: null,
            label: this.currentUser?.email,
            name: this.currentUser?.name,
            recipientType: 'SENDER'
          }
        ];
      }
    }

    if (params?.data?.source === TICKET_SOURCE.Communication) {
      variables = {
        ...variables,
        sendMail: true,
        conversationScope: params?.conversationScope,
        recipientDetails: recipients
      };
    } else {
      variables = {
        ...variables,
        toUsers: [
          {
            email: params?.toUsers?.email
          }
        ],
        ccUsers: ccUsers,
        bccUsers: bccUsers,
        fromMailbox: { boxId: params?.data?.selectedMailbox?.boxId },
        inlineImages: params?.template?.inlineImages
      };
    }

    return variables;
  };

  globalChatSuccessCallBack = (status, res) => {
    if (status === 'success') {
      toast('success', 'Conversation added successfully');
    }
  };

  onTemplateChange = (updatedData) => {
    if (this.props?.sendAgentCollisionDataFromFloatingEditor) {
      this.props?.sendAgentCollisionDataFromFloatingEditor();
    }
  };

  onGlobalConversationClose = (globalConversation) => {
    EventEmitter.dispatch('ticketGlobalConversationClosed', globalConversation);
    useActivityTracker({
      event: 'Cancelled the pop out without sending a reply'
    });
    this.props?.saveGlobalConversationTemplate(globalConversation);
  };

  pinChat = () => {
    const ticket = this.props.ticket;
    const globalConversations = getGlobalConversations();
    // This will give the previously present conversation;
    if (!isEmpty(globalConversations) && globalConversations?.[0]) {
      const conversationToSave = globalConversations?.[0];
      if (this.props?.saveGlobalConversationTemplate) {
        this.props?.saveGlobalConversationTemplate(conversationToSave, true);
      }
    }

    const defaultTemplate = {
      name: '',
      content: dompurify.sanitize(this.props.template) || '',
      placeholdersUsed: '',
      mentions: [],
      attachments: [],
      inlineImages: []
    };
    const usersConfig = {
      property: 'userId',
      query: GET_CLIENT_USERS,
      params: {
        client: AccountClient,
        variables: { input: { clientId: ticket?.client?.accountId } }
      },
      methodName: 'getClientUserAssociationsList'
    };
    const CHAT_PARAMS = {
      id: ticket?.ticketId,
      subject: ticket?.subject,
      module: 'TICKET',
      data: {
        ...ticket,
        selectedMailbox: this.state.selectedMailbox,
        splitOptions: this.props?.splitOptions,
        notificationTemplateByConstant: this.props
          ?.notificationTemplateByConstant
      },
      ccUsers: this.state.ccUsers,
      bccUsers: this.state.bccUsers,
      toUsers: ticket?.requester,
      recipients: this.state.recipients,
      conversationScope:
        this.state.isPrivateChannel === true ? 'PRIVATE' : 'PUBLIC',
      recipientsConfig: { ...this.recipientsConfig },
      toUsersConfig: usersConfig,
      ccUsersConfig: { ...usersConfig, isMulti: true, creatable: true },
      bccUsersConfig: { ...usersConfig, isMulti: true },
      formatData: this.formatData,
      template: this.state.template,
      editorDetails: this.props.editorDetails || {},
      mutationClient: TicketClient,
      // TODO
      mutationAPI:
        ticket?.source === TICKET_SOURCE.Communication
          ? SAVE_TICKET_INTEGRATION_CONVERSATION
          : SAVE_TICKET_CONVERSATION,
      callBack: this.globalChatSuccessCallBack,
      defaultTemplate: defaultTemplate,
      onTemplateChange: this.onTemplateChange,
      attachmentUploadParams: this.props?.uploadParams,
      attachmentUploadUrl: this.props.attachmentUploadUrl,
      checkHideCloseModal: this.props
        ?.checkHideGlobalTicketConversationCloseModal,
      onOpen: this.props?.checkIfActionToolbarDisabled,
      onTitleClick: this.props?.openTicketFromGlobalConversation,
      primaryAction: GlobalTicketConversationAction,
      onClose: this.onGlobalConversationClose,
      toolbarContent: GlobalTicketConversationUsers,
      showWorklog: true,
      workItem: ticket,
      showAIRephrase: this.props?.showAIRephrase,
      aiPrompts: this.props?.prompts
    };
    EventEmitter.dispatch('createGlobalConversation', CHAT_PARAMS);
    useActivityTracker({
      event: 'Conversation was popped out'
    });
    if (this.props?.resetConversationMode) {
      this.props?.resetConversationMode(false);
    }
  };

  toggleEditorToolbar = () => {
    const editor = this.editorRef.current?.FroalaEditorRef?.current;
    // While adding link it won't be appended properly and gets added as new text
    // Reached out to Froala team and added editor?.events?.focus()
    // This ensures that when the toolbar is toggled, the editor also gains focus, allowing the toolbar to behave as expected.
    editor?.events?.focus();
    this.setState((prevState) => ({
      hideToolbar: !prevState.hideToolbar
    }));
  };

  toggleChannel = () => {
    if (!this.props.ccAvailable) {
      return;
    }
    this.setState((prevState) => ({
      isPrivateChannel: !prevState.isPrivateChannel
    }));
  };

  generateReceiverOptions = (users) => {
    const requester = this.props.ticket.requester || null;
    const additionalRequesters = this.props.ticket.additionalRequester || [];
    const currentUserId = this.currentUser?.userId;

    //  Filter users with roleType TECHNICIAN and not the current user
    const technicianUsers =
      users?.filter(
        (user) =>
          user?.user?.role?.roleType?.type === 'TECHNICIAN' &&
          user?.user?.userId !== currentUserId
      ) || [];
    // Get requester and additionalRequesters, filtering out the current user
    const otherRequesters = [requester, ...additionalRequesters]
      ?.filter((user) => user && user?.userId && user?.userId !== currentUserId)
      .map((user) => {
        return {
          user: user
        };
      });
    // Merge techs and requesters
    const allFilterUsers = [...technicianUsers, ...otherRequesters];
    // Deduplicate by userId
    const uniqueUsers = allFilterUsers?.filter(
      (user, index, self) =>
        index === self.findIndex((u) => u?.user?.userId === user?.user?.userId)
    );
    return uniqueUsers?.map((user) => {
      return {
        ...user,
        label: user?.user?.name,
        value: user?.user?.email
      };
    });
  };

  customOptionComponent = (option) => {
    const { label } = option?.data;
    const { innerRef, innerProps } = option;
    return (
      <div ref={innerRef} {...innerProps} className="flex center p8 ptr">
        <div className="mr8">
          <Avatar initials={label?.[0]} size={'extraSmall'} />
        </div>
        {label}
      </div>
    );
  };

  removeReceiver = (data) => {
    console.log(data, this.state.recipients);
    this.setState((prevState) => {
      return {
        recipients: prevState.recipients.filter(
          (receiver) => receiver?.value !== data?.value
        )
      };
    });
  };

  customMultiValueComponent = (option) => {
    const { data, innerRef, innerProps } = option;
    return (
      <div ref={innerRef} {...innerProps} className="flex center m4 ptr">
        <Item>
          <Avatar
            name={data?.label}
            initials={data?.label[0]}
            size="extraSmall"
          />
          <div className="ml-5">{data?.label}</div>
          {!data?.isFixed && (
            <Delete
              className="multi-text-delete"
              tabIndex="-1"
              role="button"
              onClick={() => this.removeReceiver(data)}
            >
              <Button
                plain
                icon={
                  <div className="fx center">
                    <SVGIcon name="Close" color="black" size="xs" />
                  </div>
                }
              />
            </Delete>
          )}
        </Item>
      </div>
    );
  };

  render() {
    const {
      editorState,
      placeholders,
      submitActionLoading,
      template,
      showCc,
      showBcc,
      isUploading,
      isDisabled,
      mailboxes,
      selectedMailbox,
      popoverActive,
      isPublicNote,
      editorWidthIsSmall
    } = this.state;
    const {
      intl,
      toolbarHidden,
      ReadOnly,
      onMessageSubmit,
      ticket,
      project,
      ccAvailable,
      module,
      details,
      allowMentions,
      attachmentUploadUrl,
      uploadParams,
      placeholder,
      splitOptions,
      isSplit,
      resolvedConversationLoading,
      enablePublic,
      notificationTemplateByConstant,
      convertConversationToWorklog
    } = this.props;

    const aiRephraseKeys = getAIRephraseKeys(intl);

    const activator = (
      <div className="pointer fx actr" onClick={this.togglePopoverActive}>
        <div className="flex center">
          <T2 className="ml8">
            {selectedMailbox?.outgoingAddress ? (
              <>{`${selectedMailbox?.outgoingAddress}`}</>
            ) : (
              <>
                <FormattedMessage id="ticket.conversation.mailbox.select.placeholder" />
              </>
            )}
          </T2>
          <div className="ml8 flex center">
            <SVGIcon name="ArrowDown" />
          </div>
        </div>
      </div>
    );

    // return (
    //   <EmailEditor
    //     focusEditor
    //     template={template}
    //     updateTemplate={this.updateTemplate}
    //     handleFileAttachments={this.handleFileAttachments}
    //     handleAttachmentsDeletion={this.handleAttachmentsDeletion}
    //     placeholder={placeholder}
    //     module={module || 'TICKET'}
    //     details={details || { operation: 'CREATE' }}
    //     allowMentions={allowMentions}
    //     isUploading={isUploading}
    //   />
    // );

    const onSummaryTypeChange = (type) => {
      return {
        variables: {
          input: {
            itemId: ticket?.ticketId,
            itemType: 'TICKET',
            summaryCase: 'NOTE',
            summaryType: type
          }
        },
        summaryType: type
      };
    };

    const onCopy = async (content) => {
      EventEmitter.dispatch('insertEditorContent', dompurifier(content));
    };

    const onArticleCopy = async (content) => {
      await EventEmitter.dispatch(
        'insertOnlyEditorContent',
        dompurifier(content)
      );
      let updatedContent = this.editorRef.current.FroalaEditorRef?.current?.html?.get();
      this.updateEditorState(updatedContent);
    };

    const onRephraseCopy = (content, params) => {
      if (this.editorRef.current?.FroalaEditorRef) {
        EventEmitter.dispatch('insertEditorContent', dompurifier(content));
      } else {
        EventEmitter.dispatch('replaceEditorContent', dompurifier(content));
      }
    };

    const onAIRephraseFeedback = (params) => {
      const featureId = params?.data?.currentPrompt?.featureId;
      const actualMessage = params?.data?.selectedText;

      const thumbsUp = params?.type === 'HELPFUL';

      const response = params?.response;

      if (
        featureId &&
        actualMessage &&
        response &&
        this.props?.sendAIFeatureFeedback
      ) {
        const input = {
          feature: {
            featureId: featureId
          },
          ratingType: 'THUMBS',
          rating: thumbsUp ? '1' : '0', // 0 for down thumps
          prompt: {
            actualMessage: actualMessage,
            aiMessage: response
          }
        };

        this.props?.sendAIFeatureFeedback({
          variables: {
            input: input
          }
        });
      }
    };

    const getSelectedText = () => {
      if (this.editorRef.current) {
        if (module === 'TICKET_CONVERSATION') {
          if (this.editorRef.current?.FroalaEditorRef?.current?.selection) {
            return this.editorRef.current?.FroalaEditorRef?.current?.selection.text();
          }
          return null;
        } else {
          const range = this.editorRef.current?.getEditorSelection();
          if (range) {
            const editor = this.editorRef.current?.getEditor();
            const unprivilegedEditor = this.editorRef.current?.makeUnprivilegedEditor(
              editor
            );
            // You may now use the unprivilegedEditor proxy methods
            return unprivilegedEditor?.getText(range.index, range.length);
          }
          return null;
        }
      }
      return null;
    };

    const disableSubmit =
      this.state.recipients.length === 0 && this.state.isPrivateChannel;

    return (
      <StyledChatContainer
        ref={this.editorContainerRef}
        color={
          this.props?.module === 'TICKET_NOTE' || this.props?.module === 'NOTE'
            ? '#fffae4'
            : '#ffffff'
        }
        isDescOrder={this.props.isDescOrder}
        className="position-relative height450 max-height-450"
      >
        <Card AdaptHeight padding="sizeSmall">
          <div className="fhp position-relative overflow-y-auto x-hidden">
            {enablePublic && (
              <div className="fx fw mb-10">
                <P1 className="fx actr pl10">
                  <B1>
                    <FormattedMessage id="invoice.details.notes" />
                  </B1>
                </P1>
                <div className="flex actr g10 mlauto">
                  {this.props?.showAIRephrase && (
                    <TicketNoteAIActions
                      editorRef={this.editorRef}
                      onCopy={onRephraseCopy}
                      ticket={ticket}
                      type="REPHRASE"
                      hideButtonText
                      prompts={this.props?.prompts || []}
                      data={{
                        Api: APPLY_AI_PROMPT,
                        accessorKey: 'applyAIPrompt'
                      }}
                      sendFeedback={onAIRephraseFeedback}
                      featureName="PROMPT_BUILDER"
                      headingText={getTranslatedText(
                        intl,
                        'common.rephrase.text'
                      )}
                      headingIcon={'AIWand'}
                      loadingText={aiRephraseKeys?.loadingText}
                      successText={aiRephraseKeys?.successText}
                      copyButtonText={getTranslatedText(
                        intl,
                        'common.insert.text'
                      )}
                      copySuccessText={getTranslatedText(
                        intl,
                        'common.inserted'
                      )}
                      mixpanelEventOnClick={{
                        event: 'Rephrased with prompt - Ticket note reply',
                        data: {
                          ticketId: ticket?.ticketId
                        }
                      }}
                    />
                  )}
                  {ticket && !this.props?.showAIRephrase && (
                    <AIComponent
                      //  hideCopyPaste
                      onCopy={onCopy}
                      featureName="TICKET_CONVERSATION_SUMMARIZE"
                      workItem={{
                        itemId: ticket?.ticketId,
                        module: 'TICKET'
                      }}
                      summaryCase="NOTE"
                      summaryType="POINTS"
                      variables={{
                        input: {
                          itemId: ticket?.ticketId,
                          itemType: 'TICKET',
                          summaryCase: 'NOTE',
                          summaryType: 'POINTS'
                        }
                      }}
                      headingText={getTranslatedText(
                        intl,
                        'msp.ai.ticket.note.summary'
                      )}
                      headingIcon={'AI_TICKET'}
                      copyButtonText={getTranslatedText(
                        intl,
                        'common.insert.text'
                      )}
                      copySuccessText={getTranslatedText(
                        intl,
                        'common.inserted'
                      )}
                      loadingText={[
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.note.summary.loading.message.1'
                        ),
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.note.summary.loading.message.2'
                        ),
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.note.summary.loading.message.3'
                        ),
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.note.summary.loading.message.4'
                        ),
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.note.summary.loading.message.5'
                        ),
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.note.summary.loading.message.6'
                        ),
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.note.summary.loading.message.7'
                        )
                      ]}
                      successText={[
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.summary.success.message.1'
                        ),
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.summary.success.message.2'
                        ),
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.summary.success.message.3'
                        ),
                        getTranslatedText(
                          intl,
                          'msp.ai.ticket.summary.success.message.4'
                        )
                      ]}
                      type="SUMMARY"
                      mixpanelEventOnClick={{
                        event: 'Clicked on AI note summary',
                        data: {
                          ticketId: ticket?.ticketId
                        }
                      }}
                    />
                  )}

                  <Checkbox
                    checked={isPublicNote}
                    onChange={this.updateNoteAsPublic}
                    label={getTranslatedText(
                      intl,
                      'workItem.details.note.mark.as.public'
                    )}
                  />
                </div>
              </div>
            )}

            {ccAvailable && ticket?.source !== TICKET_SOURCE.Communication && (
              <>
                <EditorHeader className="flex mb4">
                  <div>
                    <div className="flex center mb10">
                      <div>
                        <FormattedMessage id="ticket.details.chat.from" />
                      </div>
                      {mailboxes.length > 1 ? (
                        <Popover
                          active={popoverActive}
                          activator={activator}
                          preferredPosition="below"
                          preferredAlignment="left"
                          onClose={this.togglePopoverActive}
                        >
                          <MailboxItemHolder>
                            {mailboxes.map((el) => {
                              return (
                                <div className="fx actr">
                                  <MailboxItem
                                    onClick={() => {
                                      this.setState({
                                        selectedMailbox: el
                                      });
                                      this.props.setMailboxGlobalState(el);
                                      this.togglePopoverActive();
                                      this.props.refetchDefaultReplyTemplate(
                                        {
                                          input: {
                                            ticket: {
                                              ticketId: ticket.ticketId
                                            },
                                            mailbox: {
                                              boxId: el.boxId
                                            }
                                          }
                                        },
                                        (content) => {
                                          this.updateTemplate({
                                            content: content
                                          });
                                        }
                                      );
                                    }}
                                    isVerified={el?.outgoingDomainVerified}
                                  >
                                    {el?.outgoingAddress}
                                  </MailboxItem>
                                  {!el?.outgoingDomainVerified && (
                                    <Tippy
                                      content={
                                        <ToolTipContainer className="fx">
                                          <FormattedMessage id="ticket.details.mailbox.email.unverified" />
                                        </ToolTipContainer>
                                      }
                                      duration={250}
                                      interactive
                                      placement="right"
                                      arrow={false}
                                      allowHTML
                                      appendTo={document.body}
                                    >
                                      <EmailStatus className="fx actr">
                                        <SVGIcon
                                          name="InlineError"
                                          color="#ff0055"
                                          size="sm"
                                        />
                                      </EmailStatus>
                                    </Tippy>
                                  )}
                                </div>
                              );
                            })}
                          </MailboxItemHolder>
                        </Popover>
                      ) : (
                        <T2 className="ml8">{`${selectedMailbox?.outgoingAddress}`}</T2>
                      )}
                      {(isEmpty(selectedMailbox) ||
                        !selectedMailbox?.outgoingDomainVerified) && (
                        <Tippy
                          content={
                            <ToolTipContainer>
                              {isEmpty(selectedMailbox) ? (
                                <FormattedMessage id="ticket.details.mailbox.select.error.message" />
                              ) : (
                                <FormattedMessage id="ticket.details.mailbox.email.unverified" />
                              )}
                            </ToolTipContainer>
                          }
                          duration={250}
                          interactive
                          placement="right"
                          arrow={false}
                          allowHTML
                          appendTo={document.body}
                        >
                          <EmailStatus className="fx actr">
                            <SVGIcon
                              name="InlineError"
                              color="#ff0055"
                              size="sm"
                            />
                          </EmailStatus>
                        </Tippy>
                      )}
                    </div>
                    {ticket?.requester && (
                      <div className="flex center">
                        <div className="uppercase">
                          <FormattedMessage id="ticket.details.chat.to" />
                        </div>
                        <T2 className="ml8">{`${
                          ticket?.requester?.firstName
                        } ${ticket?.requester?.lastName || ''}`}</T2>
                        <T2 className="ml8 f-12">
                          ({ticket?.requester?.email})
                        </T2>
                      </div>
                    )}
                  </div>
                  {this.globalConversationFlag ? (
                    <div className="mlauto">
                      <ToolbarActions
                        pinChat={this.pinChat}
                        disabled={
                          isEmpty(selectedMailbox) ||
                          !selectedMailbox?.outgoingDomainVerified
                        }
                        updateTemplateContent={this.updateTemplateContent}
                        updateState={this.updateState}
                        showAIRephrase={this.props?.showAIRephrase}
                        editorRef={this.editorRef}
                        onAIRephraseCopy={onRephraseCopy}
                        onArticleCopy={onArticleCopy}
                        prompts={this.props?.prompts || []}
                        sendFeedback={onAIRephraseFeedback}
                        ticketId={ticket?.ticketId}
                        source={ticket?.source}
                      />
                    </div>
                  ) : (
                    <HiddenActions
                      updateTemplateContent={this.updateTemplateContent}
                      updateState={this.updateState}
                      globalConversationFlag={this.globalConversationFlag}
                    />
                  )}
                </EditorHeader>
                <div>
                  {showCc && (
                    <CopyMailUsers>
                      <div className="title">CC</div>
                      <SelectUsers
                        updateField={this.updateCopyUsers.bind(this, 'ccUsers')}
                        property="userId"
                        query={GET_CLIENT_USERS}
                        params={{
                          client: AccountClient,
                          variables: {
                            input: { clientId: ticket?.client?.accountId }
                          }
                        }}
                        methodName="getClientUserAssociationsList"
                        field="cc"
                        value={this.state.ccUsers}
                        isMulti
                        creatable
                      />
                    </CopyMailUsers>
                  )}
                  {showBcc && (
                    <CopyMailUsers>
                      <div className="title">BCC</div>
                      <SelectUsers
                        updateField={this.updateCopyUsers.bind(
                          this,
                          'bccUsers'
                        )}
                        property="userId"
                        methodName="getClientUserAssociationsList"
                        query={GET_CLIENT_USERS}
                        params={{
                          client: AccountClient,
                          variables: {
                            input: { clientId: ticket?.client?.accountId }
                          }
                        }}
                        field="bcc"
                        value={this.state.bccUsers}
                        isMulti
                        creatable
                      />
                    </CopyMailUsers>
                  )}
                </div>
              </>
            )}

            {ccAvailable && ticket?.source === TICKET_SOURCE.Communication && (
              <EditorHeader className="flex mb4">
                <div className="fx w100 astart">
                  <div
                    className="fx g5 pt8 pointer"
                    onClick={this.toggleChannel}
                  >
                    <div
                      className={`flex br8 p4 fhp ${
                        !this.state.isPrivateChannel ? 'bg-green' : 'bg-grey'
                      }`}
                    >
                      <SVGIcon
                        name={
                          !this.state.isPrivateChannel
                            ? 'GlobeSharedView'
                            : 'PrivateArticlePlain'
                        }
                        size="sm"
                      />
                    </div>
                    <FormattedMessage
                      id={
                        !this.state.isPrivateChannel
                          ? 'common.public.channel'
                          : 'common.private.channel'
                      }
                    />
                    <div className="flex center">
                      <SVGIcon name="ArrowDown" />
                    </div>
                  </div>
                  {this.state.isPrivateChannel && (
                    <div className="w75">
                      <SelectUsers
                        updateField={(val) =>
                          this.updateCopyUsers('recipients', val)
                        }
                        {...this.recipientsConfig}
                        value={this.state.recipients}
                      />
                    </div>
                  )}
                </div>
                <div className="mlauto">
                  <ToolbarActions
                    pinChat={this.pinChat}
                    updateTemplateContent={this.updateTemplateContent}
                    updateState={this.updateState}
                    showAIRephrase={this.props?.showAIRephrase}
                    editorRef={this.editorRef}
                    onAIRephraseCopy={onRephraseCopy}
                    onArticleCopy={onArticleCopy}
                    prompts={this.props?.prompts || []}
                    sendFeedback={onAIRephraseFeedback}
                    ticketId={ticket?.ticketId}
                    source={ticket?.source}
                  />
                </div>
              </EditorHeader>
            )}
            {/* {module === 'TICKET_CONVERSATION' ? ( */}
            <EditorHolder
              className="editorHolder"
              isBannerVisible={this.state?.isBannerVisible}
            >
              {resolvedConversationLoading && (
                <div className="mt20">
                  <Loader />
                </div>
              )}
              <Editor
                focusEditor
                editorRef={this.editorRef}
                template={template}
                updateTemplate={this.updateTemplate}
                module={module || 'TICKET'}
                details={details}
                handleFileAttachments={this.handleFileAttachments}
                handleAttachmentsDeletion={this.handleAttachmentsDeletion}
                title="Add Attachments"
                description="Upload/drop files here"
                allowMultiple
                toolbarSticky={false}
                config={{
                  htmlUntouched: true
                }}
                allowMentions={allowMentions}
                hideToolbar={this.state.hideToolbar}
              />
            </EditorHolder>
            {/* ) : (
            <EmailEditorHolder>
              {resolvedConversationLoading && (
                <div className="mt20">
                  <Loader />
                </div>
              )}
              <EmailEditor
                focusEditor
                editorRef={this.editorRef}
                template={template}
                updateTemplate={this.updateTemplate}
                handleFileAttachments={this.handleFileAttachments}
                handleAttachmentsDeletion={this.handleAttachmentsDeletion}
                placeholder={placeholder}
                module={module || 'TICKET'}
                details={details || { operation: 'CREATE' }}
                allowMentions={allowMentions}
                isUploading={isUploading}
                scrollIntoView={this.props?.scrollIntoView}
              />
            </EmailEditorHolder>
          )} */}

            <BannerComponent
              bannerKey="ticketReplyBanner"
              defaultMessage={getTranslatedText(
                intl,
                'ticket.reply.convert.worklog.info'
              )}
              onBannerChange={(bool) => {
                this.setState({
                  isBannerVisible: bool
                });
              }}
            />

            <div className="fx actr">
              <div className="fx actr fg1">
                {this.props?.concurrentUsersTyping?.length ? (
                  <TypingStatus className="fx actr mr-10">
                    <SVGIcon name="Edit" color="#4B8413" />
                    <FormattedMessage
                      id={
                        this.props?.concurrentUsersTyping?.length > 2
                          ? 'common.collaborator.several.typing'
                          : 'common.collaborator.isTyping'
                      }
                      values={{
                        collabUserName: this.props?.concurrentUsersTyping
                          ?.slice(0, 2)
                          ?.map((viewer) => viewer?.user?.name)
                          .join(', ')
                      }}
                    />
                  </TypingStatus>
                ) : null}
                {this.props.hideToolbar !== false && (
                  <span className="mr-10">
                    <Button
                      className="toggleFroalaToolbarMenu mr"
                      onClick={this.toggleEditorToolbar}
                    >
                      A
                    </Button>
                  </span>
                )}

                {convertConversationToWorklog && (
                  <AccessControl
                    roleToCheck={{
                      roles: ['tickets.edit', 'serviceCatalog.view']
                    }}
                    render={
                      <div className="fx actr fg1">
                        <TimerActionsFromReply
                          froalaEditor
                          bannerKey="ticketReplyBanner"
                          editorRef={this.editorRef}
                          workItem={ticket || project}
                        />
                      </div>
                    }
                  />
                )}
              </div>
              <ActionButtons
                className={`fx end jend save-card  ${(module ===
                'TICKET_CONVERSATION'
                  ? ''
                  : 'pt20',
                this.props?.ticketRevampFlag ? 'z1' : '')}`}
                id="actionsContinerActionsHolder"
                position={this.props?.actionButtonStyles?.position}
                right={this.props?.actionButtonStyles?.right}
                bottom={this.props?.actionButtonStyles?.bottom}
              >
                <ButtonGroup className="fx">
                  <Button
                    plainSecondary
                    onClick={this.clearContent}
                    customClassName="actionsCancelBtn"
                    // disabled={isDisabled}
                  >
                    <FormattedMessage id="common.cancel" />
                  </Button>
                  {isSplit ? (
                    <Tooltip
                      distance={15}
                      title={this.getSaveRestrictedError(intl)}
                      position="top-start"
                      inertia
                      trigger="mouseenter"
                      animation="shift"
                      animateFill={false}
                      disabled={!isDisabled}
                    >
                      <Button
                        loading={submitActionLoading}
                        onClick={this.onMessageSubmit}
                        primary
                        disabled={disableSubmit || isDisabled || isUploading}
                        connectedDisclosure={{
                          disabled: disableSubmit || isDisabled || isUploading,
                          actions: splitOptions.map((el) => {
                            return {
                              content: (
                                <div className="fx actr">
                                  <div
                                    className="fg1"
                                    onClick={this.onMessageSubmit.bind(
                                      this,
                                      el
                                    )}
                                  >
                                    {el.content}
                                  </div>

                                  {notificationTemplateByConstant?.activated &&
                                    el.statusType === 'close' && (
                                      <span
                                        onClick={this.onMessageSubmitWithoutNotif.bind(
                                          this,
                                          el.name
                                        )}
                                        className="fx actr mlauto ptr"
                                      >
                                        <Tooltip
                                          html={
                                            <div className="p3 f12">
                                              {getTranslatedText(
                                                intl,
                                                'ticket.action.closeWithoutNotification'
                                              )}
                                            </div>
                                          }
                                          delay={400}
                                          duration={250}
                                          position="bottom"
                                          distance={10}
                                          inertia
                                          trigger="mouseenter"
                                          animation="shift"
                                          animateFill={false}
                                        >
                                          <Badge
                                            radial
                                            status="attention"
                                            // status={cancelNotify ? 'attention' : 'secondary'}
                                            icon={
                                              <SVGIcon
                                                name="NotificationsBellCrossed"
                                                size="sm"
                                              />
                                            }
                                          />
                                        </Tooltip>
                                      </span>
                                    )}
                                </div>
                              )
                            };
                          })
                        }}
                        icon={
                          !submitActionLoading && (
                            <SVGIcon name="SendWhite" color="#fff" />
                          )
                        }
                      >
                        <FormattedMessage id="ticket.details.chat.submit" />
                      </Button>
                    </Tooltip>
                  ) : (
                    <Button
                      loading={submitActionLoading}
                      primary
                      disabled={disableSubmit || isDisabled || isUploading}
                      onClick={this.onMessageSubmit}
                      customClassName="actionsSaveBtn"
                      icon={
                        !submitActionLoading && (
                          <SVGIcon name="SendWhite" color="#fff" />
                        )
                      }
                    >
                      <FormattedMessage
                        id={
                          CHAT_ACTION_TEXT[module] ||
                          'ticket.details.chat.submit'
                        }
                      />
                    </Button>
                  )}
                </ButtonGroup>
              </ActionButtons>
            </div>
          </div>
        </Card>
      </StyledChatContainer>
    );
  }
}

export default injectIntl(ActionContainer);
